<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Monitor',

  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss' scoped>

</style>
